/**
 * Stable CSS class names for E2E — Create return / Active step 2.
 */
export const CRAS2 = {
    root: 'create-return-step2',
    loadingSection: 'create-return-step2__loading-section',

    barcodeCol: 'create-return-step2__barcode-col',
    barcodePaper: 'create-return-step2-input--barcode-paper',
    barcodeInput: 'create-return-step2-input--barcode-text',
    barcodeButton: 'create-return-step2-input--button-barcode-add',

    quickActionCol: 'create-return-step2__quick-action-col',
    quickActionText: 'create-return-step2__quick-action-text',

    reasonSelectCol: 'create-return-step2__reason-select-col',
    reasonFormControl: 'create-return-step2-input__form-control--reason',
    reasonSelect: 'create-return-step2-input--select-reason',
    reasonSelectItem: 'create-return-step2-input--select-reason-item',

    sellerAutocompleteCol: 'create-return-step2__seller-autocomplete-col',
    sellerAutocompleteWrap: 'create-return-step2-input--seller-autocomplete-wrap',

    applyAllCol: 'create-return-step2__apply-all-col',
    applyAllButton: 'create-return-step2-input--button-apply-all',

    exceptionRow: 'create-return-step2__exception-row',
    exceptionControl: 'create-return-step2-input--exception-control',
    exceptionCheckbox: 'create-return-step2-input--checkbox-exception',

    productsSection: 'create-return-step2__products-section',
    productRowWrap: 'create-return-step2__product-row-wrap',

    totalsRow: 'create-return-step2__totals-row',
    totalsWrap: 'create-return-step2__totals-wrap',
    totalsText: 'create-return-step2__totals-text',

    continueRow: 'create-return-step2__continue-row',
    continueButton: 'create-return-step2-input--button-continue',
} as const;

export const cras2Cls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

